import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { MetricsElement, exposeMetrics, PropTypes as MetricsPropTypes } from "react-metrics";
import AccountIcon from 'modules/Common/components/svg/AccountIcon';
import { trackClick } from 'utils/AnalyticsUtils';
import { SSOLogin, SSOMyAccount } from 'modules/Common/reducers/skysso';

export class PureLoginButton extends Component {

  static contextTypes = {
    metrics: MetricsPropTypes.metrics
  }

  static propTypes = {
    auth: PropTypes.object.isRequired,
    device: PropTypes.string.isRequired,
    openMyAccount: PropTypes.func.isRequired,
    openLogin: PropTypes.func.isRequired
  };

  constructor(props) {
    super(props);
    this.showMyAccount = this.showMyAccount.bind(this);
  }

  showMyAccount() {
    if (this.props.auth.loggedIn) {
      this.props.openMyAccount()
    }
    else {
      this.props.openLogin()
    }
  }

  getLabel() {
    if (this.props.auth.loggedIn) {
      return "My Account";
    }

    if (this.props.device === "mobile") {
      return "Log in"
    }

    return "Log in / Register";
  }

  render() {
    return (
      <MetricsElement>
        <button className="user-bar" id={`user-bar-${this.props.device}`}
                disabled={!this.props.auth.ssoApi}
                onClick={this.showMyAccount}
                {...trackClick("login", {loggedIn: this.props.auth.loggedIn ? 'logged-in' : 'not logged-in'})}
        >
                <AccountIcon title="My Account" loggedIn={this.props.auth.loggedIn} />
                <span>{this.getLabel()}</span>
        </button>
      </MetricsElement>
    );
  }
}

const mapDispatchToProps = dispatch => {
  return {
    openLogin: () => dispatch(SSOLogin()),
    openMyAccount: () => dispatch(SSOMyAccount())
  }
}

export default exposeMetrics(
  connect(
    state => ({ auth: state.common.auth }), 
    mapDispatchToProps
  )(PureLoginButton)
);



// WEBPACK FOOTER //
// ./modules/Common/containers/LoginButton.js